/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import React from 'react';

import { _date } from '@mairistem/administres-utils';
import { Table } from '@mairistem/composants';

import type { Acte } from '@/types';

interface Props {
  acte: Acte;
}

const ActeTableLineNaissance = ({ acte }: Props) => (
  <>
    <Table.Cell content={_date.short(acte.dateNaissance)} />
    <Table.Cell content={acte.nomClassementEnfant} />
    <Table.Cell
      content={[acte.nomClassementPere, acte.nomClassementMere]
        .filter((v) => !_.isEmpty(v))
        .join(' - ')}
    />
  </>
);

export default ActeTableLineNaissance;
